import { useEffect, useRef } from 'react';
import { TaskStatusType } from '@/app/enums/TaskStatusType';
import { type TaskInfoDto } from '@/app/models/TaskInfoDto';
import { isAwaitedByModal, isRunning, notifyTaskFinished } from '@/app/modules/task/core/_utils';

/**
 * Avisa quando uma tarefa que este navegador viu rodando termina fora do modal. Tarefa que já chega finalizada
 * (recarregar a página) não avisa: para isso existe o contador do sino. `suppressed`: a aba Tarefas está aberta.
 */
export const useTaskFinishToasts = (tasks: TaskInfoDto<string>[], suppressed: boolean) => {
  const previous = useRef(new Map<string, TaskStatusType>());

  useEffect(() => {
    tasks.forEach((task) => {
      const finishedNow = previous.current.get(task.name) === TaskStatusType.RUNNING && !isRunning(task);
      if (!finishedNow || suppressed || isAwaitedByModal(task.name)) return;

      notifyTaskFinished(task);
    });
    previous.current = new Map(tasks.map((task) => [task.name, task.status]));
  }, [tasks, suppressed]);
};
